import { useState } from 'react';

import { PLATTFORM_NAME, type UmsatzPlattform } from '../api';
import { formatiereEuro } from '../warenkorb';

const PLATTFORMEN: readonly UmsatzPlattform[] = ['lieferando', 'foodora', 'webshop'];

/**
 * Online bezahlte Lieferdienst-Bestellung erfassen: Plattform, Bestellnummer und
 * Lieferart. Es entsteht kein Registrierkassenbeleg – die Zahlung lief über die
 * Plattform (kein Barumsatz). Zahlt der Kunde vor Ort, wird normal kassiert.
 */
export function PlattformDialog(props: {
  summeCent: number;
  laeuft: boolean;
  onErfassen: (a: {
    plattform: UmsatzPlattform;
    externeId: string;
    lieferart: 'lieferung' | 'abholung';
  }) => void;
  onAbbrechen: () => void;
}) {
  const [plattform, setPlattform] = useState<UmsatzPlattform>('lieferando');
  const [externeId, setExterneId] = useState('');
  const [lieferart, setLieferart] = useState<'lieferung' | 'abholung'>('lieferung');
  const gueltig = externeId.trim() !== '' && !props.laeuft;

  return (
    <div className="zahlung-dialog" role="dialog" aria-modal="true">
      <div className="karte">
        <h2>Online bezahlt</h2>
        <div className="betrag">{formatiereEuro(props.summeCent)} €</div>
        <div className="chips" role="group" aria-label="Plattform">
          {PLATTFORMEN.map((p) => (
            <button
              key={p}
              type="button"
              className={plattform === p ? 'aktiv' : ''}
              onClick={() => {
                setPlattform(p);
              }}
            >
              {PLATTFORM_NAME[p]}
            </button>
          ))}
        </div>
        <label>
          Bestellnummer der Plattform
          <input
            value={externeId}
            maxLength={64}
            autoFocus
            placeholder="z. B. 4711-ABCD"
            onChange={(e) => {
              setExterneId(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && gueltig) {
                props.onErfassen({ plattform, externeId: externeId.trim(), lieferart });
              }
            }}
          />
        </label>
        <div className="chips" role="group" aria-label="Lieferart">
          {(['lieferung', 'abholung'] as const).map((l) => (
            <button
              key={l}
              type="button"
              className={lieferart === l ? 'aktiv' : ''}
              onClick={() => {
                setLieferart(l);
              }}
            >
              {l === 'lieferung' ? 'Lieferung' : 'Abholung'}
            </button>
          ))}
        </div>
        <p className="hinweis">
          Nur für Bestellungen, die bei der Plattform bereits online bezahlt sind: kein
          Registrierkassenbeleg, nicht im Umsatzzähler, aber mit Steuersatz für die Buchhaltung
          aufgezeichnet. Zahlt der Kunde bei Abholung bar oder mit Karte, normal kassieren.
        </p>
        <div className="zeile" style={{ justifyContent: 'center' }}>
          <button
            className="taste gross"
            disabled={!gueltig}
            onClick={() => {
              props.onErfassen({ plattform, externeId: externeId.trim(), lieferart });
            }}
          >
            {props.laeuft ? 'Wird erfasst …' : `${PLATTFORM_NAME[plattform]}-Bestellung erfassen`}
          </button>
          <button className="taste zweit" disabled={props.laeuft} onClick={props.onAbbrechen}>
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
}
